import { jsx as _jsx } from "react/jsx-runtime";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkOutlinedIcon from "@mui/icons-material/BookmarkOutlined";
import { Box, IconButton } from "@mui/material";
import useThrottle from "hooks/useThrottle";
// Управляемый компонент: состояние и тост — на стороне родителя. Здесь только
// отрисовка по isFavorite и вызов setFavorite по клику (через throttle).
var Favorite = function (_a) {
    var isFavorite = _a.isFavorite, setFavorite = _a.setFavorite, _b = _a.size, size = _b === void 0 ? 20 : _b;
    var throttle = useThrottle(300);
    var handleClick = function () {
        if (!throttle())
            return;
        setFavorite();
    };
    return (_jsx(Box, { sx: { display: "flex", justifyContent: "center", alignItems: "center" }, children: _jsx(IconButton, { onClick: handleClick, sx: {
                color: isFavorite ? "rgb(255, 198, 24)" : "rgba(255,255,255,0.9)",
                p: 0,
                transition: "color 150ms ease",
                "&:hover": {
                    color: isFavorite ? "rgb(255, 198, 24)" : "rgba(255,255,255,1)",
                },
                "& svg": { fontSize: size },
            }, children: isFavorite ? _jsx(BookmarkOutlinedIcon, {}) : _jsx(BookmarkBorderIcon, {}) }) }));
};
export default Favorite;
